import 'bootstrap';

import 'leaflet';

import $ from "jquery";
import {Kernel} from "@mvc/view-plugin/src/Resources/assets/js/Core/Kernel";
import {MyGreiffMap} from "./assets/MyGreiffMap";
import {QrCodeScanner} from "./assets/QrCodeScanner";
import {NominatimClient} from "@BaseTheme/components/assets/NominatimClient";
import {registerComponent} from "@Core/Register";

class MyGreiff{
    $el = null;
    maps = {}

    constructor($el,id){
        this.$el = $el;
        this.routeLink = '';
        this.init()
        let data = ''
    }
    init(){
        this.$form = $('#searchByCode');
        if(this.$form.length>0){
            registerComponent('qr-code-scanner', QrCodeScanner);
        }

        this.routeLink = $('#route-get-product').data('route-link') || '';
        if($('#materials_map').length>0 && $('#confectionery_map').length>0){
            this.initMaps()
            this.setMarkers()
            /* On mobile devices, we want to start with the maps collapsed */
            if(window.screen.width < 768) {
                this.toggleMaps()
            }
        }
        this.addEvents()


    }
    initMaps(){
        this.maps.materials = new MyGreiffMap(this.$el,{
            container_id:'materials_map',
            center:{
                latitude:58.26328691139734,
                longitude:-13.534773873071922,
            },
            zoom:3,
            maxZoom:9
        });


        this.maps.confectionery = new MyGreiffMap(this.$el,{
            container_id:'confectionery_map',
            center:{
                latitude:58.26328691139734,
                longitude:-13.534773873071922,
            },
            zoom:3,
            maxZoom:5
        });
    }

    toggleMaps() {
        /* HACK: There's not really any better way of doing this with this infra :/ */
        for(const button of this.$el[0].getElementsByClassName("filter-btn")) {
            button.click();
        }
    }
    a
    /**
     * Verbindet pCodes in 100er-Gruppen:
     * alle 100er mit allen 200ern, alle 200er mit allen 300ern usw.
     */
    connectPCodeBuckets(mapInstance, items, options = {}) {
        const groups = new Map();

        for (const it of (items || [])) {
            const id = String(it?.id ?? '').trim();
            if (!id) continue;

            const p = parseInt(it?.pCode, 10);
            if (!Number.isFinite(p)) continue;

            const bucket = Math.floor(p / 100) * 100;

            if (!groups.has(bucket)) groups.set(bucket, []);
            groups.get(bucket).push(id);
        }

        const bucketKeys = Array.from(groups.keys()).sort((a, b) => a - b);
        if (bucketKeys.length < 2) return [];

        const lines = [];

        for (let i = 0; i < bucketKeys.length - 1; i++) {
            const fromIds = groups.get(bucketKeys[i]) || [];
            const toIds   = groups.get(bucketKeys[i + 1]) || [];

            for (const fromId of fromIds) {
                for (const toId of toIds) {
                    const res = mapInstance.addConnectionById(fromId, toId, options);
                    if (!res) continue;
                    Array.isArray(res) ? lines.push(...res) : lines.push(res);
                }
            }
        }

        return lines;
    }
    setMarkers(map_name=null,tab=null){
        if (map_name) this.maps[map_name].clearMap();
        const params = new URLSearchParams(window.location.search);

        $.ajax({
            url: this.routeLink,
            dataType: "json",
            success: async (res) => {
                try {
                    const nominatim = new NominatimClient();

                    let materials = res?.materialherkunft;
                    let material = materials[0];
                    if (tab) {
                        let selected = materials.filter(obj => obj.desc === tab);
                        if (selected && selected.length) {
                            material = selected[0];
                        }
                    }
                    if (!material.items.length) return;
                    await this.plotByCountry({
                        source: res,
                        items: material?.items || [],
                        nominatim,
                        map:this.maps.materials,
                        countryKey: 'location',
                        labelKey: 'label',
                        codeKey: 'pCodeBez',
                        radius: 25000,
                        acceptLanguage: 'de'
                    });

                    this.connectPCodeBuckets(this.maps.materials, material.items, {
                        color: '#b10022',
                        weight: 2,
                        opacity: 1
                    });

                    let confectioneries = res?.konfektionsbetrieb || [];
                    for(let confectionery of confectioneries){
                        await this.plotByCountry({
                            source: res,
                            items:confectionery?.items || [],
                            nominatim,
                            map:this.maps.confectionery,
                            countryKey: 'location',
                            labelKey:   'label',
                            ignoreLabel: true,
                            codeKey:    'pCodeBez',
                            radius:     25000,
                            acceptLanguage: 'de'
                        });

                        this.connectPCodeBuckets(this.maps.confectionery, confectionery.items, {
                            color: '#b10022',
                            weight: 2,
                            opacity: 1
                        });
                    }
                    /*for(let map of Object.values(this.maps)){
                        const coords = [];
                        for (const marker of Object.values(map.markersByKey)){
                            coords.push({lat:marker.lat, lng:marker.lng});
                        }
                        setTimeout(()=>{
                            map.map.fitBounds(coords)
                        }, 200);
                    }*/

                } catch (err) {
                    console.error("Fehler im Success-Handler:", err);
                }
            },
            error: (err)=>{
                console.log(err)
            }
        });
    }
    toTitleCase(str){
        if (!str) return "";
        return str
            .toLowerCase()
            .split(/\s+/)
            .map(w => w.charAt(0).toUpperCase() + w.slice(1))
            .join(" ");
    }
    /**
     * Plotet gruppierte Locations pro Land.
     *
     * @param {Object} cfg
     * @param {Object} cfg.source                - deine API-Response (z.B. res)
     * @param {Array} cfg.items                  - Die Items die auf der Karte angezeigt werden
     * @param {NominatimClient} cfg.nominatim    - Instanz deiner NominatimClient-Klasse
     * @param {MyGreiffMap} cfg.map              - Instanz deiner MyGreiffMap
     * @param {string} [cfg.countryKey='location']  - Feldname fürs Land
     * @param {string} [cfg.labelKey='label']       - Feldname fürs Label
     * @param {Boolean} [cfg.ignoreLabel=false]     - ignorier Label überprüfung
     * @param {string} [cfg.codeKey='pCodeBez']     - Feldname zur Deduplizierung
     * @param {number} [cfg.radius=25000]           - Kreisradius in Metern
     * @param {string} [cfg.acceptLanguage='de']    - Accept-Language für Nominatim
     */
    plotByCountry(cfg) {
        const {
            source,
            items,
            nominatim,
            map,
            countryKey = 'location',
            labelKey   = 'label',
            ignoreLabel = false,
            codeKey    = 'pCodeBez',
            radius     = 25000,
            acceptLanguage = 'de'
        } = cfg;

        const arr = Array.isArray(items) ? items : [];
        if (!arr.length) return Promise.resolve();

        const groups = new Map();

        for (const it of arr) {
            const rawLabel = String(it?.[labelKey] ?? '').trim();
            if (!ignoreLabel && rawLabel.length === 0) continue;

            const country = String(it?.[countryKey] ?? '').trim();
            if (!country) continue;

            const code   = String(it?.[codeKey] ?? '').trim();
            const id = String(it?.id ?? '').trim();
            if (!id) continue;

            const pCode = String(it?.pCode ?? '').trim();

            const key = country.toLowerCase();
            if (!groups.has(key)) groups.set(key, { countryName: country, items: [] });

            const bucket = groups.get(key).items;
            if (!bucket.some(x => x.id === id)) {
                bucket.push({
                    id,
                    pCode,
                    pCodeBez: code,
                    label: this.toTitleCase(it.label+' '+it.pCodeBez+' '+it.location),
                    latitude: it.latitude,
                    longitude: it.longitude
                });
            }
        }

        // Promise chain for all countries
        const tasks = Array.from(groups.values()).map(group => {
            return nominatim
                .search({ q: group.countryName, limit: 1 }, { acceptLanguage })
                .then(resp => {
                    if (!resp?.length) return;
                    const d = resp[0];
                    const center = { lat: parseFloat(d.lat), lng: parseFloat(d.lon) };
                    if (!Number.isFinite(center.lat) || !Number.isFinite(center.lng)) return;

                    map.addCountryLocations(center, group.items, {
                        radius,
                        popupFormatter: it => (it.label && it.label.trim())
                            ? it.label.trim()
                            : (it.pCodeBez || '')
                    });

                }).catch(e => {
                    console.warn('Nominatim-Fehler für', group.countryName, e);
                });
        });

        // wait until all countries have been processed
        return Promise.all(tasks);
    }
    addEvents(){
        this.$el.on("click touch",'.filter-btn',(e)=>{
            let $target = $(e.currentTarget);
            $target.parents('.tab-material-origin').find('.list-hidden').toggleClass( "d-none" );
        });
        this.$el.on('click touch','.set-pointer',(e)=>{
            let $target = $(e.currentTarget);
            let maps = $target.parents('.tab-material-origin.row')
            let map_name = null
            for (let map of maps ) {
                let classList = map.classList
                map_name = 'materials'
                if (classList.contains('confectionery')) map_name = 'confectionery'
            }

            let id = $target.data('id')
            console.log(id)
            console.log(this.maps[map_name].markersByKey)
            if(this.maps[map_name].markersByKey[id]){
                let marker = this.maps[map_name].markersByKey[id]
                this.maps[map_name].map.setView([marker.lat, marker.lng], 5)
            }

        })
        this.$el.on('click touch','.leaflet-new[data-bs-toggle=tab]',(e)=>{
            let $target = $(e.currentTarget);
            let tab = $target.html().trim()
            let maps = $target.parents('.tab-material-origin.row')
            let map_name = null
            for (let map of maps ) {
                let classList = map.classList
                map_name = 'materials'
                if (classList.contains('confectionery')) map_name = 'confectionery'
            }
            if (!map_name) return
            this.setMarkers(map_name,tab)
        })

        this.$form.on('submit', (e)=>{
            e.preventDefault();
            const val = $('#articleByCode').val()
            window.location.href='/'+val;
        });
    }
}
$(document).ready(function () {
    new MyGreiff($(document));
})